import { useState } from 'react';
import { Dropdown, Modal, notification } from 'antd';
import { BsThreeDots } from 'react-icons/bs';
import { useTranslation } from 'react-i18next';
import { PERMITTED_UNASSIGN_DRIVER } from '../../const/booking.constants';
import { IBooking } from '../../interfaces/booking.interface';
import { getBooking, unassignDriver } from '../../api/bookings.api';
import { EBookingStatus } from '../../enums/booking.enum';

const { confirm } = Modal;

const Actions = ({ record }: { record: IBooking }) => {
    const { t } = useTranslation('bookings', { keyPrefix: 'TABLE' });

    const [loading, setLoading] = useState<boolean>(false);

    const handleFreeDriver = async (e: any) => {
        setLoading(true);

        if (e && typeof e.stopPropagation === 'function') {
            e.stopPropagation();
        }

        const bookingID = record._id;
        const bookingDetail = await getBooking(bookingID);
        const driverID = bookingDetail.driver as string;

        if (!driverID) {
            notification.error({
                message: 'Error',
                description: t('NO_DRIVER_ASSIGNED'),
            });
            setLoading(false);
            return;
        }

        confirm({
            title: t('UNASSIGN_DRIVER'),
            content: t('UNASSIGN_DRIVER_DESCRIPTION'),
            okButtonProps: { loading },
            onOk: () => {
                unassignDriver(bookingID, driverID)
                    .then((response) => {
                        console.log(response);
                    })
                    .catch((error: any) => {
                        const description = error.response.data.description || t('FAILED_TO_UNASSIGN_DRIVER');
                        notification.error({
                            message: 'Error',
                            description,
                        });
                    })
                    .finally(() => setLoading(false));
            },
            onCancel: () => { },
        });
        return;
    };

    return (
        <Dropdown
            placement="bottomRight"
            trigger={['click']}
            menu={{
                items: [
                    {
                        key: 'freeDriver',
                        label: t('FREE_DRIVER'),
                        disabled: loading || !PERMITTED_UNASSIGN_DRIVER.includes(record.statusText as EBookingStatus),
                        onClick: handleFreeDriver,
                    },
                ],
            }}
        >
            <BsThreeDots size={16} />
        </Dropdown>
    );
};

export { Actions };
